export enum UserTypes {
  staff,
  externalUser,
  petOwner,
}
